"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultTextCardSx = exports.DefaultRTECardSx = exports.DefaultIconCardSx = exports.DefaultBackgroundCardSx = void 0;
var _boolean = require("../../utils/type-checks/boolean");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
const merge = require("deepmerge"),
  DefaultBackgroundCardSx = (theme, src, imageHeight, variant) => {
    return {
      boxShadow: "none",
      border: "0.1rem solid rgba(0, 0, 0, 0.15)",
      "li": {
        textAlign: "left"
      },
      textAlign: variant,
      minWidth: "27.5rem",
      ".backgroundCard__image": {
        backgroundImage: `url(${src})`,
        backgroundPosition: "top center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: imageHeight
      },
      ".backgroundCard__content": {
        padding: "2.5rem",
        height: {
          xs: "auto",
          sm: `calc(100% - ${imageHeight})`
        }
      },
      ".backgroundCard__innerContent": {
        display: "flex",
        flexDirection: "column",
        alignItems: variant === "left" ? "flex-start" : "center",
        justifyContent: "space-between",
        height: "100%",
        ".MuiButtonBase-root": {
          marginTop: "2rem !important",
          marginLeft: variant === "left" ? 0 : "1.4rem"
        },
        "h1, h2, h3, h4, h5, h6": merge(theme.mixins.headings.CardHeading.content, {}),
        "p": {
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize,
          lineHeight: "1.4"
        }
      }
    };
  };
exports.DefaultBackgroundCardSx = DefaultBackgroundCardSx;
const DefaultIconCardSx = (theme, isThinCard) => {
  return {
    boxShadow: "none",
    border: "0.1rem solid rgba(0, 0, 0, 0.15)",
    display: "flex",
    "li": {
      textAlign: "left"
    },
    "h4": {
      alignSelf: {
        xs: "center",
        sm: "flex-start"
      }
    },
    justifyContent: {
      xs: "center",
      sm: "flex-start"
    },
    ".iconCard__content": {
      alignItems: {
        xs: "center",
        sm: "flex-start"
      },
      display: "flex",
      flexDirection: (0, _boolean.isBoolean)(isThinCard) && isThinCard ? "column" : {
        xs: "column",
        sm: "row"
      },
      justifyContent: "space-evenly",
      padding: (0, _boolean.isBoolean)(isThinCard) && isThinCard ? "3rem 2rem" : {
        xs: "3rem 2.5rem",
        sm: "4rem 3rem"
      },
      textAlign: {
        xs: "center",
        sm: "left"
      },
      "img": {
        height: "auto",
        width: {
          xs: "10rem",
          md: "14rem"
        },
        paddingRight: {
          xs: 0,
          sm: "2.5rem"
        },
        marginBottom: (0, _boolean.isBoolean)(isThinCard) && isThinCard ? "1rem" : 0
      },
      ".iconCard__InnerContent": {
        display: "flex",
        flexDirection: "column",
        justifyContent: {
          xs: "space-evenly",
          sm: "space-between"
        },
        alignItems: {
          xs: "center",
          sm: "flex-start"
        },
        height: "100%",
        marginTop: {
          xs: "1rem",
          sm: 0
        },
        "h1, h2, h3, h4, h5, h6": {
          ...theme.mixins.headings.CardHeading.content
        },
        "p": {
          margin: 0,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize,
          lineHeight: "1.4"
        },
        ".IconCard__button": {
          marginLeft: {
            sm: 0
          },
          marginTop: "2rem",
          fontSize: "1.4rem"
        }
      }
    }
  };
};
exports.DefaultIconCardSx = DefaultIconCardSx;
const DefaultTextCardSx = (theme, subLandingColor, landingStyles, variant) => {
  const {
    color: landingColor,
    icon: landingIcon
  } = (0, _object.isObject)(landingStyles) ? landingStyles : {};
  return {
    "&.textCard--left": {
      justifyContent: {
        xs: "center",
        sm: "flex-start"
      },
      ".textCard__content .textCard__InnerContent": {
        alignItems: {
          xs: "center",
          sm: "flex-start"
        },
        textAlign: {
          xs: "center",
          sm: "left"
        }
      }
    },
    "&.textCard--center": {
      justifyContent: "center",
      "ul": {
        paddingLeft: "2rem"
      },
      ".textCard__content .textCard__InnerContent": {
        alignItems: "center",
        textAlign: "center",
        ".TextCard__button": {
          marginRight: "0" // to have button centered properly.
        }
      }
    },
    boxShadow: "none",
    border: "0.1rem solid rgba(0, 0, 0, 0.15)",
    borderTop: landingColor ? `1.8rem solid ${landingColor}` : "0.1rem solid rgba(0, 0, 0, 0.15)",
    display: "flex",
    position: "relative",
    overflow: "visible",
    margin: "2rem auto",
    minWidth: "27.5rem",
    "li": {
      textAlign: "left"
    },
    "&::before": {
      content: "''",
      zIndex: 2,
      position: "absolute",
      top: "-.65rem",
      left: "50%",
      transform: "translateX(-50%)",
      width: "30%",
      height: "1.3rem",
      backgroundColor: (0, _string.isStringOfLength)(subLandingColor) ? subLandingColor : "transparent",
      border: "none",
      display: (0, _string.isStringOfLength)(subLandingColor) ? "block" : "none"
    },
    "&::after": {
      content: "''",
      position: "absolute",
      backgroundImage: landingIcon || "",
      backgroundSize: landingIcon ? "contain" : "",
      backgroundRepeat: landingIcon ? "no-repeat" : "",
      backgroundPosition: "bottom right",
      height: "5.3rem",
      width: "5.3rem",
      bottom: "2rem",
      right: "2rem",
      display: (0, _object.isObject)(landingStyles) ? "block" : "none"
    },
    "&.textCard .textCard__content": {
      padding: "3rem 2.5rem"
    },
    "&.textCard .textCard__content .textCard__InnerContent": {
      display: "flex",
      height: "100%",
      flexDirection: "column",
      justifyContent: {
        xs: "space-evenly",
        sm: "space-between"
      }
    },
    ".textCard__content": {
      alignItems: "center",
      display: "flex",
      flexDirection: {
        xs: "column",
        sm: "row"
      },
      justifyContent: "center",
      textAlign: {
        xs: "center",
        sm: "left"
      },
      ".textCard__InnerContent": {
        "h1, h2, h3, h4, h5, h6": {
          ...theme.mixins.headings.CardHeading.content
        },
        "p": {
          margin: "0",
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize,
          lineHeight: "1.4"
        },
        ".TextCard__button": {
          marginLeft: {
            sm: "0"
          },
          marginTop: "2rem",
          fontSize: "1.4rem",
          whiteSpace: {
            xs: "nowrap",
            sm: "normal"
          },
          zIndex: "1"
        }
      }
    }
  };
};
exports.DefaultTextCardSx = DefaultTextCardSx;
const DefaultRTECardSx = theme => {
  return {
    boxShadow: "none",
    color: theme.palette.text.primary,
    padding: "3rem 2.5rem",
    textAlign: "center",
    "div": {
      marginBottom: "2rem",
      textAlign: "left",
      "h1, h2, h3, h4, h5, h6": merge(theme.mixins.headings.RTEHeading.content, {}),
      "p": {
        "p": {
          marginBottom: "1.6rem",
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.fontSize,
          lineHeight: theme.typography.body1.lineHeight
        }
      },
      "ul li": {
        marginBottom: "1.6rem",
        "&::marker": {
          color: theme.palette.primary.main
        }
      }
    }
  };
};
exports.DefaultRTECardSx = DefaultRTECardSx;